import { render, staticRenderFns } from "./SurveyTabLinks.vue?vue&type=template&id=5d5fd60b"
import script from "./SurveyTabLinks.vue?vue&type=script&lang=js"
export * from "./SurveyTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports